import { ReactComponent as TomatoIcon } from './tomato.svg';

export default TomatoIcon;
